import {Map, List} from "immutable";
import {appContainer} from "../contexts/app";
import Resource from "./resource";
import {fromImmutable, toImmutable, setInState, setListInState, deleteInState, validate, validateEmail} from "./hooks";

export default app => {
  const service = app.service("api/invitations");

  const InvitationRecord = Resource(
    service,
    {
      account_id: "",
      email: "",
      permissions: Map({
        resources: Map({
          buildings: List(),
          markerTypeCategories: List()
        }),
        edit: Map({
          resources: false,
          users: false,
          account: false
        }),
        groups: List()
      })
    },
    {
      async resend() {
        if (!this._id) {
          return new Error("Method resend() cannot be called on a record without an _id");
        }
        return app.service("api/invitation-resends").create({_id: this._id});
      }
    }
  );

  const validateInvitation = validate({
    email: validateEmail
  });

  appContainer.InvitationRecord = InvitationRecord;
  app.set("InvitationRecord", InvitationRecord);

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [fromImmutable, validateInvitation],
      update: [fromImmutable, validateInvitation],
      patch: [fromImmutable, validateInvitation],
      remove: []
    },

    after: {
      all: [toImmutable(InvitationRecord)],
      find: [setListInState("invitations")],
      get: [setInState("invitations")],
      create: [setInState("invitations")],
      update: [setInState("invitations")],
      patch: [setInState("invitations")],
      remove: [deleteInState("invitations")]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/invitations.js